import { render, staticRenderFns } from "./ui-alert.component.vue?vue&type=template&id=637f9800&"
import script from "./ui-alert.component.vue?vue&type=script&lang=ts&"
export * from "./ui-alert.component.vue?vue&type=script&lang=ts&"
import style0 from "./ui-alert.component.vue?vue&type=style&index=0&id=637f9800&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports